export const SHOP_SET_STUDENT_ID = 'SHOP_SET_STUDENT_ID';
export const SHOW_CUTOFF_WARNING = 'SHOW_CUTOFF_WARNING';
export const SHOW_ALACARTE_WARNING = 'SHOW_ALACARTE_WARNING';
export const SHOP_SET_ERRORS = 'SHOP_SET_ERRORS';
export const SHOW_REIMBURSABLE_WARNING = 'SHOW_REIMBURSABLE_WARNING';
export const SHOP_SET_DISTRICT_ID = 'SHOP_SET_DISTRICT_ID';
export const SHOP_SET_SITE_ID = 'SHOP_SET_SITE_ID';
